export interface QmodelJsonMaterial {
  id: string; // Id starts from 1, not 0.
  clr?: string; // Color, Eg: "#000000"
  shi?: number; // Shininess / specularity. Range: 0 -> 100.
  lty?: number; // is line type, Eg 0 or 1.
  tr?: number; // transparency, Range 0 -> 100, - 100 is invisible and 0 is fully visible.
  pic?: string; // Albedo/Diffuse texture, Eg: data:image/png;base64,iV...CC
}

export const createQmodelMaterialKey = (qModelMaterial: QmodelJsonMaterial): string => {
  return [qModelMaterial.id, qModelMaterial.clr, qModelMaterial.pic, qModelMaterial.tr, qModelMaterial.lty, qModelMaterial.shi].join('-');
};
